import {
  withAccountHeader,
  withAuthHeader,
  withRetries,
  compose,
  withE2ERequestStubbing,
} from './util';
import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';

interface GetSubjectsParams {
  projectId: string;
  identifier?: Array<string>;
  name?: string;
  cohortId?: string;
}

const rootPath = '/phc/api/subjects/search';
const urls = {
  post: () => `${rootPath}`,
};

export default class SubjectsSearchService {
  subjectsSearchService: AxiosInstance;

  constructor(options?: AxiosRequestConfig) {
    this.subjectsSearchService = compose(
      withE2ERequestStubbing,
      withAccountHeader,
      withAuthHeader,
      withRetries(),
    )(axios.create(options || {}));
  }

  getSubjects = async ({
    projectId,
    identifier,
    name,
    cohortId,
  }: GetSubjectsParams) => {
    return this.subjectsSearchService.post(urls.post(), {
      pageSize: 50,
      projectId,
      identifier,
      name,
      cohortId: cohortId || undefined,
    });
  };
}
